import axios from "axios";

import { tasksApi } from "../model/api";

export const tasksV2Api = tasksApi;
